import injector from 'vue-inject'

class PlatformUtils {
  constructor () {
    this.androidApp = 'ANDROID_APP'
    this.androidWeb = 'ANDROID_WEB'
    this.iosApp = 'IOS_APP'
    this.iosWeb = 'IOS_WEB'
    this.autoApp = 'AUTO_APP'
    this.autoWeb = 'AUTO_WEB'
  }

  isWeb = platform => platform === this.autoWeb || platform === this.androidWeb || platform === this.iosWeb
  isApp = platform => platform === this.autoApp || platform === this.androidApp || platform === this.iosApp
  isAndroid = platform => platform === this.androidApp || platform === this.androidWeb
  isIos = platform => platform === this.iosApp || platform === this.iosWeb
  isAndroidApp = platform => platform === this.androidApp
  isAndroidWeb = platform => platform === this.androidWeb
  isIosApp = platform => platform === this.iosApp
  isIosWeb = platform => platform === this.iosWeb
}

injector.service('platformUtils', [], PlatformUtils)
